import { GlobalToastList, Icon } from '@antoree/ant-ui';
import { generateUId } from '@antoree/helpers';
import {
  NOTIFICATION,
  useNotificationContext,
} from 'contexts/NotificationContext';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useHistory } from 'react-router-dom';
import styles from './Notification.module.scss';

type Props = {};

type NotificationWithSender = {
  senderId?: string;
} & typeof NOTIFICATION;

const NotificationToast = (props: Props) => {
  const intl = useIntl();
  const { notification: notificationDataRaw } = useNotificationContext();
  const notificationData = notificationDataRaw as NotificationWithSender;
  const location = useLocation();
  const history = useHistory();
  const [toasts, setToasts] = useState<any[]>([]);

  const removeToast = () => {
    setToasts([]);
  };
  const { changeNotification } = useNotificationContext();

  const handleToastClick = () => {
    const conversationId = (notificationData as any).conversationId;
    if (conversationId) {
      history.push(`/chat/${conversationId}`);
    } else {
      history.push('/chat');
    }
    removeToast();
  };

  const renderContent = (content: string) => {
    if (!content) return null;

    let iconType = '';
    let text = content;

    const photoLabel = intl.formatMessage({
      id: 'chat.attachment.photo',
      defaultMessage: 'Photo',
    });
    const videoLabel = intl.formatMessage({
      id: 'chat.attachment.video',
      defaultMessage: 'Video',
    });
    const fileLabel = intl.formatMessage({
      id: 'chat.attachment.file',
      defaultMessage: 'File',
    });

    if (content.includes('📷') || content.toLowerCase().includes('photo')) {
      iconType = 'image';
      text = content.replace('📷', '').trim() || photoLabel;
    } else if (
      content.includes('🎥') ||
      content.toLowerCase().includes('video')
    ) {
      iconType = 'videoPlayer';
      text = content.replace('🎥', '').trim() || videoLabel;
    } else if (
      content.includes('📎') ||
      content.toLowerCase().includes('file')
    ) {
      iconType = 'document';
      text = content.replace('📎', '').trim() || fileLabel;
    }

    if (iconType) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Icon type={iconType} size="s" />
          <span>{text}</span>
        </div>
      );
    }

    return <span>{content}</span>;
  };

  useEffect(() => {
    if (notificationData.createdAt && notificationData.content) {
      const date = new Date(notificationData.createdAt);
      const dateStr = `${date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      })} ${date.toLocaleDateString()}`;

      const newMessageTitle = intl.formatMessage({
        id: 'chat.toast.new_message',
        defaultMessage: 'New Message',
      });

      setToasts([
        {
          className: `${styles.globalToastItem}`,
          id: generateUId(),
          color: 'success',
          text: (
            <div
              style={{
                whiteSpace: 'pre-line',
                cursor: 'pointer',
                padding: '4px',
              }}
              onClick={handleToastClick}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '4px',
                }}
              >
                <Icon type="bell" size="m" color="#14B24C" />
                <b style={{ color: '#14B24C' }}>{newMessageTitle}</b>
              </div>
              <div style={{ paddingLeft: '28px', color: '#1f2937' }}>
                {renderContent(notificationData.content)}
              </div>
              <div
                style={{
                  fontSize: 11,
                  color: '#9ca3af',
                  paddingLeft: '28px',
                  marginTop: '4px',
                }}
              >
                {dateStr}
              </div>
            </div>
          ),
        },
      ]);
    }
  }, [
    notificationData.createdAt,
    notificationData.content,
    (notificationData as any).senderId,
    (notificationData as any).conversationId,
    intl,
  ]);

  useEffect(() => {
    if (toasts.length === 0 && notificationData.createdAt) {
      changeNotification(NOTIFICATION);
    }
  }, [toasts]);

  const isChatPage = location.pathname.startsWith('/chat');

  return (
    <>
      {notificationData.createdAt && !isChatPage && (
        <GlobalToastList
          className={styles.globalToastList}
          toasts={toasts}
          side="right"
          dismissToast={removeToast}
          toastLifeTimeMs={5000}
        />
      )}
    </>
  );
};

export default NotificationToast;
//note
